import { Api } from "@relode/core";

import { DashboardTypeResponse } from ".";
import { JobManagerContactResponse as JobManagerContactResponse } from "../../shared";

export const dashboardService = {
    getDashboardType: async (): Promise<DashboardTypeResponse> => {
        const url = "/dashboard";

        const result = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({ name: "dashboardService.getDashboardType" })
            .throwOnAbort()
            .get<DashboardTypeResponse>();

        return result;
    },

    getJobManagerDetails: async (): Promise<JobManagerContactResponse> => {
        const url = "/dashboard/jobManager";
        const result = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({ name: "dashboardService.getJobManagerDetails" })
            .throwOnAbort()
            .get<JobManagerContactResponse>();

        return result;
    },
};
